/*
 * Liberty configurator (sections/liberty-configurator.liquid)
 *
 * Renders the size / color / hardware / lock pickers from the metaobject data embedded in
 * #lbc-data, keeps the hero photo in sync, shows the live price, and tells the Meta Variant
 * Builder checkout block what is selected by dispatching `configurator:updated` with
 * { selections, modelId } — the block prices server-side (draft order), so the price shown
 * here is a preview that mirrors the backend's pricing tiers (pricingEngine.ts):
 *   default_price -> dependencies.price_by_size[modelId][size] -> [size] -> dependencies[size]
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('lbc-data');
  var root = document.querySelector('.lbc');
  if (!dataEl || !root) return;

  var D;
  try {
    D = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('[lbc] could not parse configurator data', e);
    return;
  }

  var KEY = { ls_size: 'size', ls_trim: 'trim', ls_color: 'color', ls_hardware_color: 'hw', ls_handle_type: 'handle', ls_doorpanel: 'panel', ls_lock_type: 'lock', ls_upgrade: 'upgrade', ls_hinge_side: 'hinge' };
  var opts = D.options || {};
  var sizes = D.sizes || [];
  var BASE = D.base || '';
  function abs(u) { return !u ? '' : (u.indexOf('http') === 0 ? u : BASE + u); }
  // row: [size, color, hardware, lock, closedUrl, openUrl, trim]
  var layers = (D.layers || []).map(function (l) { return [l[0], l[1], l[2], l[3], abs(l[4]), abs(l[5]), l[6] || null, l[7] || null]; });
  var st = { size: null, trim: null, color: null, hw: null, handle: null, panel: null, lock: null, upgrade: null, hinge: null };
  var view = 'configured'; // 'configured' | 'open'
  var $ = function (id) { return document.getElementById(id); };

  function money(n) {
    return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sizeCfg(code) {
    for (var i = 0; i < sizes.length; i++) if (sizes[i].code === code) return sizes[i];
    return null;
  }
  // photos matching the given axes (any axis left null/undefined is not constrained)
  function photos(sizeCode, colorCode, hwCode, trimCode) {
    return layers.filter(function (l) {
      return l[0] === sizeCode && (!colorCode || l[1] === colorCode) && (!hwCode || l[2] === hwCode) && (!trimCode || l[6] === trimCode);
    });
  }
  // A finish is offered for the selected size + trim when it is photographed there. If it has no photo in
  // this trim it is still offered (showing the nearest trim's photo, with a note) when the finish is
  // photographed in at least two trims across the line — a general finish such as Black Gloss under Standard.
  // A finish photographed in a single trim only (the two-tone paints are Signature-only) stays with that trim.
  // Either way there must be at least one photo at this size to show.
  function colorOffered(sizeCode, colorCode) {
    if (!layers.length) return true;
    if (!st.trim) return photos(sizeCode, colorCode).length > 0;
    if (photos(sizeCode, colorCode, null, st.trim).length) return true;
    if (!photos(sizeCode, colorCode).length) return false;
    var seen = {};
    layers.forEach(function (l) { if (l[1] === colorCode) seen[l[6]] = 1; });
    return Object.keys(seen).length >= 2;
  }
  function lockOffered(sizeCode, lockCode) {
    if (!layers.length || !st.trim) return true;
    var any = false, inTrim = false;
    layers.forEach(function (l) {
      if (l[0] === sizeCode && l[3] === lockCode) { any = true; if (l[6] === st.trim) inTrim = true; }
    });
    return !any || inTrim;
  }
  function optionsFor(group) {
    var cfg = sizeCfg(st.size);
    if (!cfg) return [];
    return cfg.opts
      .map(function (c) { return opts[c]; })
      .filter(function (o) { return o && o.group === group; })
      // only offer colors we actually have a photo of at this size — otherwise the hero would
      // have to show a different color's photo, which is misleading
      .filter(function (o) { return group !== 'ls_color' || colorOffered(cfg.code, o.code); })
      // a lock is offered only where it is photographed in the selected trim (e.g. Dormakaba exists only under Signature);
      // a lock with no photos at this size at all stays offered
      .filter(function (o) { return group !== 'ls_lock_type' || lockOffered(cfg.code, o.code); })
      .sort(function (a, b) {
        return (a.so || 0) - (b.so || 0) || (group === 'ls_hardware_color' ? String(a.label).localeCompare(String(b.label)) : 0);
      });
  }

  // Hardware finishes offered for the selected size + color. The safe_image_layer photos are the
  // source of truth for which combinations exist, so when layers are present a finish is offered
  // only if there is a photo of it in this size + color (any lock). Without layers, fall back to
  // the option_value dependencies. (The shared dependencies list did not include Brass for
  // Marble Burgundy even though that safe is photographed and sold.)
  function hwOptions() {
    var all = optionsFor('ls_hardware_color');
    if (!layers.length) return all.filter(depsOk);
    var pool = photos(st.size, st.color, null, st.trim);
    if (!pool.length) pool = photos(st.size, st.color); // nothing photographed in this trim: use any trim's photos
    return all.filter(function (o) { return pool.some(function (l) { return l[2] === o.code; }); });
  }

  // dependencies.requires / requires_any — same shape the configurator metaobjects use elsewhere
  function depsOk(o) {
    var d = o && o.deps;
    if (!d) return true;
    function has(group, val) {
      var key = KEY[group];
      if (!key) return true; // unknown group: don't block
      var arr = Array.isArray(val) ? val : [val];
      return arr.indexOf(st[key]) !== -1;
    }
    if (d.requires) {
      for (var g in d.requires) if (!has(g, d.requires[g])) return false;
    }
    if (Array.isArray(d.requires_any) && d.requires_any.length) {
      return d.requires_any.some(function (cond) {
        return Object.keys(cond).every(function (g) { return has(g, cond[g]); });
      });
    }
    return true;
  }

  function optPrice(o) {
    if (!o) return 0;
    if (o.dp > 0) return o.dp;
    var d = o.deps;
    // trim-conditional price (engine: dependencies.price_by_trim_and_size) — authoritative when the
    // selected trim has an entry; a missing size means $0
    if (d && d.price_by_trim_and_size && st.trim && d.price_by_trim_and_size[st.trim] && typeof d.price_by_trim_and_size[st.trim] === 'object') {
      var tv = d.price_by_trim_and_size[st.trim][st.size];
      return tv != null ? (+tv || 0) : 0;
    }
    if (d && d.price_by_size) {
      var scoped = d.price_by_size[D.modelId];
      if (scoped && typeof scoped === 'object' && scoped[st.size] != null) return +scoped[st.size] || 0;
      if (d.price_by_size[st.size] != null && typeof d.price_by_size[st.size] !== 'object') return +d.price_by_size[st.size] || 0;
    }
    if (d && d[st.size] != null && typeof d[st.size] !== 'object') return +d[st.size] || 0;
    return 0;
  }

  // ---------- photos ----------
  function bestLayer() {
    var best = null, bestScore = -1;
    for (var i = 0; i < layers.length; i++) {
      var l = layers[i];
      if (l[0] !== st.size) continue;
      var score = 1;
      if (l[1] === st.color) score += 50;
      if (st.trim && l[6] === st.trim) score += 20;
      if (st.hw && l[2] === st.hw) score += 6;
      if (l[3] === st.lock) score += 5;
      if (st.hinge && l[7] === st.hinge) score += 40; // hinge side beats hardware/lock, never the color
      if (score > bestScore) { bestScore = score; best = l; }
    }
    if (!best) {
      // no photo at this size at all — any photo in the selected color
      for (var j = 0; j < layers.length; j++) {
        if (layers[j][1] === st.color) { best = layers[j]; break; }
      }
    }
    return best;
  }
  // ---------- selection rules ----------
  // first option of the group, unless the model names a preferred default (model.default_selections) that is offered
  function pickDefault(list, preferred) {
    if (preferred) for (var i = 0; i < list.length; i++) if (list[i].code === preferred) return preferred;
    return list.length ? list[0].code : null;
  }
  function normalize() {
    // defaults are simply the first option of each group, in the order they are displayed
    var trims = optionsFor('ls_trim');
    if (!trims.length) st.trim = null;
    else if (!trims.some(function (t) { return t.code === st.trim; })) st.trim = pickDefault(trims);
    var colors = optionsFor('ls_color');
    if (!colors.some(function (c) { return c.code === st.color; })) st.color = pickDefault(colors, (D.defaults || {}).ls_color);
    var hwAll = hwOptions();
    if (!hwAll.some(function (h) { return h.code === st.hw; })) st.hw = pickDefault(hwAll);
    if (!hwAll.length) st.hw = null;
    // handle style depends on the color + hardware chosen above (option_value rules), e.g. the Centurion
    // drop handle only exists on Textured Black / Black Chrome and the 3-spoke on each color's own hardware
    var handles = optionsFor('ls_handle_type').filter(depsOk);
    if (!handles.length) st.handle = null;
    else if (!handles.some(function (h) { return h.code === st.handle; })) st.handle = pickDefault(handles);
    var panels = optionsFor('ls_doorpanel');
    if (!panels.length) st.panel = null;
    else if (!panels.some(function (p) { return p.code === st.panel; })) st.panel = pickDefault(panels);
    var locks = optionsFor('ls_lock_type');
    if (!locks.some(function (l) { return l.code === st.lock; })) st.lock = pickDefault(locks);
    // hinge side (vault doors): photos are per hinge side, so the choice is a normal group
    var hinges = optionsFor('ls_hinge_side');
    if (!hinges.length) st.hinge = null;
    else if (!hinges.some(function (h) { return h.code === st.hinge; })) st.hinge = pickDefault(hinges);
    // optional add-on (e.g. the Home Series LED light package): only models that offer it get the group
    var upgrades = optionsFor('ls_upgrade');
    if (!upgrades.length) st.upgrade = null;
    else if (!upgrades.some(function (u) { return u.code === st.upgrade; })) st.upgrade = pickDefault(upgrades);
  }

  // ---------- rendering ----------
  function optImg(o, cls) {
    return o.img ? '<img class="' + cls + '" src="' + esc(o.img) + '" alt="" loading="lazy" width="72" height="72">' : '';
  }
  function priceTag(p) {
    return '<span class="lbc-card-price">' + (p > 0 ? '+' + money(p).replace('.00', '') : '') + '</span>';
  }

  // Option cards contain <img>. Re-creating them on every selection made the browser reload/repaint the
  // images (a visible flash, worst on phones), so a list is only (re)built when its SET of options changes
  // (e.g. a different size offers different finishes); a plain selection change just moves the "active"
  // state and updates prices in place on the existing elements.
  var painted = {};
  var nodeCache = {};
  function paintList(elId, codes, buildOne) {
    var el = $(elId);
    var sig = codes.join('|');
    if (painted[elId] === sig) return el; // same options: nothing to touch
    painted[elId] = sig;
    var cache = nodeCache[elId] || (nodeCache[elId] = {});
    var keep = [];
    codes.forEach(function (code) {
      var node = cache[code];
      if (!node) {
        var tmp = document.createElement('div');
        tmp.innerHTML = buildOne(code);
        node = tmp.firstElementChild;
        cache[code] = node;
      }
      keep.push(node);
    });
    // drop cards that are no longer offered (they stay in the cache), then (re)attach in order —
    // moving an existing element does not reload its image
    Array.prototype.slice.call(el.children).forEach(function (child) {
      if (keep.indexOf(child) === -1) el.removeChild(child);
    });
    keep.forEach(function (node) { el.appendChild(node); });
    return el;
  }
  function markActive(el, attr, activeCode, priceOf) {
    var nodes = el.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < nodes.length; i++) {
      var b = nodes[i];
      var code = b.getAttribute(attr);
      var on = code === activeCode;
      if (b.classList.contains('active') !== on) b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (priceOf) {
        var tag = b.querySelector('.lbc-card-price');
        if (tag) {
          var pr = priceOf(code);
          var txt = pr > 0 ? '+' + money(pr).replace('.00', '') : '';
          if (tag.textContent !== txt) tag.textContent = txt;
        }
      }
    }
  }

  function renderSizes() {
    var el = paintList('lbc-sizes', sizes.map(function (s) { return s.code; }), function (code) {
      var s = sizeCfg(code);
      return '<button type="button" class="lbc-card lbc-card--size" data-size="' + esc(s.code) + '">' +
        (s.img ? '<img src="' + esc(s.img) + '" alt="" loading="lazy" width="96" height="96">' : '') +
        '<span class="lbc-card-label">' + esc(shortSize(s)) + '</span></button>';
    });
    markActive(el, 'data-size', st.size);
    var cfg = sizeCfg(st.size);
    $('lbc-size-label').textContent = cfg ? cfg.label || cfg.name : '';
  }
  function shortSize(s) {
    // "Lincoln 25 - 60.5 x 30 x 24" -> "Lincoln 25"
    var lbl = s.label || s.name || '';
    return lbl.split(' - ')[0];
  }

  function renderTrims() {
    var list = optionsFor('ls_trim');
    $('lbc-trim-wrap').hidden = list.length === 0;
    var el = paintList('lbc-trims', list.map(function (o) { return o.code; }), function (code) {
      var o = opts[code];
      return '<button type="button" class="lbc-card lbc-card--size lbc-card--trim" data-trim="' + esc(o.code) + '">' +
        (o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy" width="96" height="96">' : '') +
        '<span class="lbc-card-label">' + esc(o.label) + '</span>' + priceTag(0) + '</button>';
    });
    markActive(el, 'data-trim', st.trim, function (c) { return optPrice(opts[c]); });
    var cur = opts[st.trim];
    var p = optPrice(cur);
    $('lbc-trim-label').textContent = cur ? cur.label + (p > 0 ? ' (+' + money(p).replace('.00', '') + ')' : '') : '';
    $('lbc-trim-desc').textContent = cur && cur.tip ? cur.tip : '';
  }

  function renderSpecs() {
    if (painted['lbc-specs'] === st.size) return; // specs only depend on the size
    painted['lbc-specs'] = st.size;
    var num = (function () { var c = sizeCfg(st.size); var m = c && c.name.match(/^[A-Z]+(\d+)/); return m ? m[1] : null; })();
    var sp = (num && D.specs && D.specs[num]) || {};
    var rows = [];
    var cfg0 = sizeCfg(st.size);
    var gun = (cfg0 && cfg0.gun) || sp.gun || D.fallbackGun;
    if (String(gun) !== '0') rows.push(['target', gun ? 'Up to ' + esc(gun) + ' long guns' : 'Gun capacity: TBA']); // 0 = not a gun safe (Home Series): no chip
    var cfg = sizeCfg(st.size);
    var wt = (cfg && cfg.weight) || sp.weight;
    rows.push(['weight', wt ? esc(wt) + ' lbs' : 'Weight: TBA']);
    var extv = (cfg0 && cfg0.ext) || sp.ext;
    var intv = (cfg0 && cfg0.int) || sp.int;
    if (extv) rows.push(['maximize', 'External: ' + esc(extv)]);
    if (intv) rows.push(['minimize', 'Internal: ' + esc(intv)]);
    rows.push(['shield-check', 'Limited Life-Time Warranty']);
    $('lbc-specs').innerHTML = rows.map(function (r) {
      return '<div class="info-item"><i data-lucide="' + r[0] + '" class="info-icon"></i><span class="info-text">' + r[1] + '</span></div>';
    }).join('');
    if (window.lucide && window.lucide.createIcons) window.lucide.createIcons();
  }

  function renderKeyFeatures() {
    var cfg = sizeCfg(st.size);
    if (!cfg) return;
    function put(id, val) {
      var el = $(id);
      if (el && val != null && val !== '' && String(el.textContent) !== String(val)) el.textContent = val;
    }
    put('kf-gun', parseFloat(cfg.gun) > 0 ? cfg.gun : null);
    put('kf-fire', cfg.fire > 0 ? cfg.fire : null);
    put('kf-security', cfg.sec > 0 ? cfg.sec : null);
  }

  function renderColors() {
    var list = optionsFor('ls_color');
    var el = paintList('lbc-colors', list.map(function (o) { return o.code; }), function (code) {
      var o = opts[code];
      var bg = o.img
        ? 'background-image:url(' + esc(o.img) + ');background-size:cover;background-position:center;'
        : 'background-color:' + esc(o.hex || '#666') + ';';
      return '<button type="button" class="lbc-swatch" data-color="' + esc(o.code) + '" title="' + esc(o.label + (o.tip ? ' \u2014 ' + o.tip : '')) + '" aria-label="' + esc(o.label) + '" style="' + bg + '"></button>';
    });
    markActive(el, 'data-color', st.color);
    var cur = opts[st.color];
    var p = optPrice(cur);
    $('lbc-color-label').textContent = cur ? cur.label + (p > 0 ? ' (+' + money(p).replace('.00', '') + ')' : '') : '';
    $('lbc-color-desc').textContent = cur && cur.tip ? cur.tip : '';
  }

  function renderCards(group, elId, dataAttr, labelId, allowedFilter) {
    var list = optionsFor(group).filter(allowedFilter || function () { return true; });
    var key = KEY[group];
    var el = paintList(elId, list.map(function (o) { return o.code; }), function (code) {
      var o = opts[code];
      return '<button type="button" class="lbc-card' + (o.img ? '' : ' lbc-card--text') + '" ' + dataAttr + '="' + esc(o.code) + '">' +
        optImg(o, 'lbc-card-img') +
        '<span class="lbc-card-label">' + esc(o.label) + '</span>' + priceTag(0) + tipIcon(o) + '</button>';
    });
    // A group with a single choice is simply part of the safe (nothing to pick), so don't advertise its
    // price as an add-on ("+$210") on the card or the selected label — it still counts in total().
    var included = list.length === 1;
    markActive(el, dataAttr, st[key], included ? function () { return 0; } : function (c) { return optPrice(opts[c]); });
    var cur = opts[st[key]];
    var p = included ? 0 : optPrice(cur);
    $(labelId).textContent = cur ? cur.label + (p > 0 ? ' (+' + money(p).replace('.00', '') + ')' : '') : '';
    return list;
  }

  function renderHero() {
    var img = $('lbc-hero-img');
    var toggle = $('lbc-open-toggle');
    var layer = bestLayer();
    var src = '';
    if (layer) {
      var hasOpen = !!layer[5];
      if (view === 'open' && !hasOpen) view = 'configured';
      src = view === 'open' ? layer[5] : layer[4];
      toggle.hidden = !hasOpen;
      toggle.textContent = view === 'open' ? 'View closed' : 'View open';
    } else {
      toggle.hidden = true;
    }
    if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
    renderThumbs();
    syncThumbs();
  }

  // ---------- thumbnail showcase ----------
  // A fixed set of ~28 photos taken from the safe_image_layer data, built once — it does NOT change as
  // selections change. Each thumbnail is a "look" (trim + color + hardware + lock); clicking one applies
  // that look while keeping the size you picked. Mix: every finish, the two-tone paints, the open-door
  // view of each trim, and the lock / hardware / trim variations.
  var showcase = [];
  function orderedOptions(group) {
    return Object.keys(opts).map(function (c) { return opts[c]; })
      .filter(function (o) { return o.group === group; })
      .sort(function (a, b) {
        return (a.so || 0) - (b.so || 0) || (group === 'ls_hardware_color' ? String(a.label).localeCompare(String(b.label)) : 0);
      });
  }
  function buildShowcase() {
    if (!layers.length || !sizes.length) return;
    var s0 = sizes[0].code;
    var trims = orderedOptions('ls_trim').map(function (o) { return o.code; });
    var hws = orderedOptions('ls_hardware_color').map(function (o) { return o.code; });
    var locks = orderedOptions('ls_lock_type').map(function (o) { return o.code; });
    var colors = orderedOptions('ls_color').map(function (o) { return o.code; });
    var seenImg = {};
    var out = [];
    var sizeOrder = sizes.map(function (z) { return z.code; });
    function sizeRankOf(code) { var i = sizeOrder.indexOf(code); return i < 0 ? 9 : i; }
    function rank(list, code) { var i = list.indexOf(code); return i < 0 ? 99 : i; }
    // best photo for a look at the smallest size; prefers the trim/hardware/lock given, then the display order
    function find(look) {
      var best = null, bestScore = 1e9;
      layers.forEach(function (l) {
        if (l[1] !== look.color) return;
        var sc = sizeRankOf(l[0]) * 7 + (look.trim ? (l[6] === look.trim ? 0 : 1000 + rank(trims, l[6]) * 100) : rank(trims, l[6]) * 100)
          + (look.hw ? (l[2] === look.hw ? 0 : 50 + rank(hws, l[2])) : rank(hws, l[2]) * 3)
          + (look.lock ? (l[3] === look.lock ? 0 : 20 + rank(locks, l[3])) : rank(locks, l[3]));
        if (sc < bestScore) { bestScore = sc; best = l; }
      });
      return best;
    }
    function add(look, kind) {
      var l = find(look);
      if (!l) return;
      var url = kind === 'open' ? l[5] : l[4];
      if (!url || seenImg[url]) return;
      seenImg[url] = true;
      out.push({ url: url, kind: kind, trim: l[6], color: l[1], hw: l[2], lock: l[3] });
    }
    // 1) every finish in the first trim, then the finishes that only exist in other trims (two-tone)
    var t0 = trims[0] || null;
    colors.forEach(function (c) { add({ color: c, trim: t0 }, 'closed'); });
    // 2) open-door view of each trim
    var c0 = colors[0];
    trims.forEach(function (t) { add({ color: c0, trim: t }, 'open'); });
    // 3) lock / hardware / trim variations on a couple of finishes
    [c0, 'ls_marble_gray', 'ls_gloss_white'].forEach(function (c) {
      if (colors.indexOf(c) < 0) return;
      locks.forEach(function (lk) { add({ color: c, trim: t0, lock: lk }, 'closed'); });
      hws.forEach(function (hw) { add({ color: c, trim: t0, hw: hw }, 'closed'); });
      trims.forEach(function (t) { add({ color: c, trim: t }, 'closed'); });
    });
    // one more open-door view in a second finish
    if (colors[1]) add({ color: colors[1], trim: t0 }, 'open');
    showcase = out.slice(0, 30);
  }
  function renderThumbs() {
    var strip = $('lbc-thumbs');
    if (!strip || strip.getAttribute('data-built')) return;
    strip.setAttribute('data-built', '1');
    strip.innerHTML = showcase.map(function (t, i) {
      var label = ((opts[t.color] || {}).label || '') + ' \u00b7 ' + ((opts[t.hw] || {}).label || '') + ' \u00b7 ' + ((opts[t.lock] || {}).label || '') + (t.kind === 'open' ? ' \u00b7 open door' : '');
      return '<button type="button" class="lbc-thumb" data-i="' + i + '" title="' + esc(label) + '" aria-label="' + esc(label) + '">' +
        '<img src="' + esc(t.url) + '" alt="" loading="lazy" width="80" height="80"></button>';
    }).join('');
  }
  // highlight the thumbnail that matches the current look (no re-render, so the strip never jumps)
  function syncThumbs() {
    document.querySelectorAll('#lbc-thumbs .lbc-thumb').forEach(function (el) {
      var t = showcase[+el.getAttribute('data-i')];
      var on = t && t.color === st.color && t.hw === st.hw && t.lock === st.lock && (!st.trim || t.trim === st.trim) && ((t.kind === 'open') === (view === 'open'));
      el.classList.toggle('active', !!on);
    });
  }

  function total() {
    var cfg = sizeCfg(st.size);
    var t = cfg ? +cfg.base : 0;
    ['ls_trim', 'ls_color', 'ls_hardware_color', 'ls_handle_type', 'ls_doorpanel', 'ls_lock_type', 'ls_upgrade', 'ls_hinge_side'].forEach(function (g) {
      var o = opts[st[KEY[g]]];
      if (o) t += optPrice(o);
    });
    return t;
  }
  function renderPrice() {
    var t = total();
    $('lbc-price').textContent = money(t);
    $('lbc-total').textContent = money(t);
  }

  function emit() {
    var selections = { ls_size: st.size, ls_color: st.color, ls_lock_type: st.lock };
    if (st.hw) selections.ls_hardware_color = st.hw;
    if (st.trim) selections.ls_trim = st.trim;
    if (st.handle) selections.ls_handle_type = st.handle;
    if (st.panel) selections.ls_doorpanel = st.panel;
    if (st.upgrade) selections.ls_upgrade = st.upgrade;
    if (st.hinge) selections.ls_hinge_side = st.hinge;
    var detail = { selections: selections, modelId: D.modelId };
    window.configuratorState = detail;
    window.dispatchEvent(new CustomEvent('configurator:updated', { detail: detail }));
  }

  function renderAll() {
    normalize();
    renderSizes();
    renderTrims();
    renderSpecs();
    renderKeyFeatures();
    renderColors();
    var hwList = renderCards('ls_hardware_color', 'lbc-hw', 'data-hw', 'lbc-hw-label', function (o) {
      return hwOptions().some(function (h) { return h.code === o.code; });
    });
    $('lbc-hw-wrap').hidden = hwList.length === 0;
    var handleList = renderCards('ls_handle_type', 'lbc-handles', 'data-handle', 'lbc-handle-label', depsOk);
    $('lbc-handle-wrap').hidden = handleList.length === 0;
    var panelList = renderCards('ls_doorpanel', 'lbc-panels', 'data-panel', 'lbc-panel-label');
    $('lbc-panel-wrap').hidden = panelList.length === 0;
    renderCards('ls_lock_type', 'lbc-locks', 'data-lock', 'lbc-lock-label');
    if ($('lbc-hinge-wrap')) {
      var hingeList = renderCards('ls_hinge_side', 'lbc-hinges', 'data-hinge', 'lbc-hinge-label');
      $('lbc-hinge-wrap').hidden = hingeList.length === 0;
    }
    if ($('lbc-upgrade-wrap')) {
      var upgradeList = renderCards('ls_upgrade', 'lbc-upgrades', 'data-upgrade', 'lbc-upgrade-label');
      $('lbc-upgrade-wrap').hidden = upgradeList.length === 0;
    }
    renderHero();
    renderPrice();
    emit();
  }

  // ---------- thumbnail strip: scrollbar is hidden, so support drag-to-scroll with a mouse
  // (touch and trackpads scroll natively) ----------
  var dragMoved = false;
  (function () {
    var strip = $('lbc-thumbs');
    if (!strip) return;
    var down = false, startX = 0, startLeft = 0;
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; dragMoved = false; startX = e.clientX; startLeft = strip.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { dragMoved = true; strip.classList.add('dragging'); }
      strip.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false; strip.classList.remove('dragging'); // dragMoved is cleared on the next pointerdown / consumed by the click handler
    });
  })();

  // ---------- tooltips ----------
  // A small (i) icon on a card opens a bubble with the option's tooltip text (option_value.tooltip):
  // hover / keyboard focus on desktop, tap on phones (tap again or tap elsewhere to close).
  function tipIcon(o) {
    if (!o || !o.tip) return '';
    return '<span class="lbc-tip" role="button" tabindex="0" data-tip="' + esc(o.code) + '" aria-label="About ' + esc(o.label) + '">i</span>';
  }
  var tipEl = null, tipFor = null, tipPinned = false;
  function hideTip() {
    if (!tipEl) tipEl = $('lbc-tooltip');
    if (tipEl) tipEl.hidden = true;
    tipFor = null;
    tipPinned = false;
  }
  function showTip(icon) {
    if (!tipEl) tipEl = $('lbc-tooltip');
    var o = opts[icon.getAttribute('data-tip')];
    if (!tipEl || !o || !o.tip) return;
    tipFor = icon;
    tipEl.innerHTML = '<strong>' + esc(o.label) + '</strong><span>' + esc(o.tip) + '</span>';
    tipEl.hidden = false;
    var r = icon.getBoundingClientRect();
    var w = tipEl.offsetWidth, h = tipEl.offsetHeight;
    var left = Math.min(Math.max(8, r.left + r.width / 2 - w / 2), window.innerWidth - w - 8);
    var top = r.top - h - 10;
    if (top < 8) top = r.bottom + 10; // not enough room above: show below
    tipEl.style.left = left + 'px';
    tipEl.style.top = top + 'px';
  }
  function toggleTip(icon) {
    if (tipFor === icon && tipPinned) { hideTip(); return; }
    showTip(icon);
    tipPinned = true;
  }
  root.addEventListener('mouseover', function (e) {
    var icon = e.target.closest('.lbc-tip');
    if (icon && !tipPinned) showTip(icon);
  });
  root.addEventListener('mouseout', function (e) {
    if (e.target.closest('.lbc-tip') && !tipPinned) hideTip();
  });
  root.addEventListener('focusin', function (e) {
    var icon = e.target.closest && e.target.closest('.lbc-tip');
    if (icon && !tipPinned) showTip(icon);
  });
  root.addEventListener('focusout', function (e) {
    if (e.target.closest && e.target.closest('.lbc-tip') && !tipPinned) hideTip();
  });
  root.addEventListener('keydown', function (e) {
    var icon = e.target.closest && e.target.closest('.lbc-tip');
    if (icon && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); toggleTip(icon); }
    if (e.key === 'Escape') hideTip();
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.lbc-tip')) hideTip();
  });
  window.addEventListener('scroll', hideTip, { passive: true });
  window.addEventListener('resize', hideTip);

  // ---------- events ----------
  root.addEventListener('click', function (e) {
    var tipBtn = e.target.closest('.lbc-tip');
    if (tipBtn) { e.preventDefault(); toggleTip(tipBtn); return; }
    var t = e.target.closest('[data-size],[data-trim],[data-color],[data-hw],[data-handle],[data-panel],[data-lock],[data-upgrade],[data-hinge],#lbc-open-toggle,.lbc-thumb');
    if (!t || !root.contains(t)) return;
    if (dragMoved) { dragMoved = false; return; } // a drag on the thumbnail strip is not a click
    if (t.id === 'lbc-open-toggle') {
      view = view === 'open' ? 'configured' : 'open';
      renderHero();
      return;
    }
    if (t.classList.contains('lbc-thumb')) {
      var look = showcase[+t.getAttribute('data-i')];
      if (!look) return;
      if (look.trim && optionsFor('ls_trim').length) st.trim = look.trim;
      st.color = look.color;
      st.hw = look.hw;
      st.lock = look.lock;
      view = look.kind === 'open' ? 'open' : 'configured';
      renderAll();
      return;
    }
    if (t.dataset.size) st.size = t.dataset.size;
    else if (t.dataset.trim) st.trim = t.dataset.trim;
    else if (t.dataset.color) st.color = t.dataset.color;
    else if (t.dataset.hw) st.hw = t.dataset.hw;
    else if (t.dataset.handle) st.handle = t.dataset.handle;
    else if (t.dataset.panel) st.panel = t.dataset.panel;
    else if (t.dataset.lock) st.lock = t.dataset.lock;
    else if (t.dataset.upgrade) st.upgrade = t.dataset.upgrade;
    else if (t.dataset.hinge) st.hinge = t.dataset.hinge;
    view = 'configured';
    renderAll();
  });

  // The checkout block resets the configurator after a successful add-to-cart / bfcache restore
  window.addEventListener('configurator:reset', function () { renderAll(); });

  // ---------- init ----------
  if (!sizes.length) {
    console.warn('[lbc] model has no size configurations');
    return;
  }
  buildShowcase();
  var want = new URLSearchParams(window.location.search).get('size');
  var startSize = sizes.filter(function (s) { return s.code === want; })[0] || sizes[0];
  st.size = startSize.code;
  renderAll();
  if (window.lucide && window.lucide.createIcons) window.lucide.createIcons();
})();
